


import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
  <path d="M1.41667 16L0 14.5833L6.58333 8L0 1.41667L1.41667 0L9.41667 8L1.41667 16Z" fill="#333333"/>
</svg>
);

export default Icon;
